import BaseClass from "./BaseClass";

export default class SharedApikeys extends BaseClass {
  static get schema() {
    return {
      uuid: {
        type: String,
        editable: false
      },
      key: {
        type: String,
        editable: false
      },
      active: {
        type: Boolean,
        editable: true
      },
      type: {
        type: String,
        editable: false
      },
      created_at: {
        type: String,
        editable: false,
        props: { sortable: true }
      },
      updated_at: {
        type: String,
        editable: false,
        props: { sortable: true }
      }
    };
  }

  _mutate(action = "save") {
    return this._api.mutate({
      mutation: require("../../graphql/apikeys/apikey_mutation.graphql"),
      variables: Object.assign({ action }, { data: this })
    });
  }

  _handleSave() {
    return this._mutate().then(res => {
      Object.assign(this, res.data.shared_apikeys);
      return "saved";
    });
  }

  _handleDelete() {
    return this._mutate("delete").then(res => {
      return "deleted";
    });
  }

  _handleRegenerate() {
    return this._mutate("regenerate").then(res => {
      Object.assign(this, res.data.shared_apikeys);
      return "regenerated";
    });
  }

  static _handleNewApikey(type = "widget") {
    return this._api
      .mutate({
        mutation: require("../../graphql/apikeys/apikey_mutation.graphql"),
        variables: Object.assign({ action: "newApikey" }, { data: { type } })
      })
      .then(res => {
        return new this(res.data.shared_apikeys);
      });
  }
}
